import * as React from 'react';
import { get } from '../helpers/http';
import * as actionTypes from '../consts/actionTypes';
import { covidCancellationHubPage } from '../consts/pageTypes';
import { changeRouteSuccess } from './routerActions';
import { __ } from '../helpers/TranslationService';
import { defaultSeo } from '../reducers/pageData';
import { setSeo } from './rootActions';

import loadable from '@loadable/component';

export const covidCancellationHubPageRouteAction = (context) => {
    const storeState = context.store.getState();
    const { apiHost } = storeState.pageData.appConfig;
    const { covidCancellationPage } = storeState;

    let { path, params, baseUrl, waitForAction, action } = context;

    const defaultActions = (title = null) => {
        const pageTitle =
            covidCancellationPage.seo?.titleOg ||
            __('Covid-19 & Cancellation Policy', 'dreamlines');
        const seo = defaultSeo;
        seo.titleOg = pageTitle;
        seo.metadesc = covidCancellationPage.seo?.metadesc;
        context.store.dispatch(setSeo(seo));
        context.store.dispatch(
            changeRouteSuccess({
                path,
                params,
                baseUrl,
                action,
                pageTitle,
                pageType: covidCancellationHubPage,
                seo,
            }),
        );

        const CovidCancellationHubPage = loadable(() =>
            import('../pages/CovidCancellationHub/CovidCancellationHub'),
        );

        return { component: <CovidCancellationHubPage />, context };
    };

    if (waitForAction) {
        return Promise.all([get(`${apiHost}/covid-cancellation-hub`)].map(P))
            .then(([payload]) => {
                context.store.dispatch({
                    type: actionTypes.loadCovidCancellationHubPageData,
                    payload,
                });
                return defaultActions();
            })
            .catch((error) => {
                console.log(error);
            });
    } else {
        return defaultActions();
    }
};

const P = (p: Promise<any>): any => {
    return p.then(
        (f) => ({ ...f }),
        (r) => ({ ...r }),
    );
};
